// src/routes/PublicOnlyRoute.jsx
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, getDashboardRoute } from "../utils/tokenUtils";
import { refreshToken } from "../services/authService";

export default function PublicOnlyRoute({ children }) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const check = async () => {
      const token = localStorage.getItem("token");

      if (isTokenValid(token)) {
        setAuthenticated(true);
        setChecking(false);
        return;
      }

      try {
        await refreshToken();
        setAuthenticated(true);
      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("userType");
        setAuthenticated(false);
      } finally {
        setChecking(false);
      }
    };

    check();
  }, []);

  if (checking) return null; // ou um spinner de tela cheia

  if (authenticated) {
    const userType = localStorage.getItem("userType");
    // Mantém o ?tab=... dos links de notificação ao ir pro dashboard
    return <Navigate to={{ pathname: getDashboardRoute(userType), search: location.search }} replace />;
  }

  return children;
}